
/* --------------- fade in anime --------------- */
document.querySelector('.menu__open-btn').addEventListener('click', function() {
    this.classList.toggle('is--active');
    document.querySelector('.menu--bg').classList.toggle('is--active');
    
    var headerHeight = document.querySelector('.header').offsetHeight;
    var accordion = document.querySelector('.accordion');
    accordion.style.height = (window.innerHeight - headerHeight) + 'px';
    accordion.style.top = headerHeight + 'px';
});


window.addEventListener('DOMContentLoaded', () => {
	//accordion
	const acc_btn = Array.from(document.querySelectorAll('.accordion__button'));

	for(let i=0; i< acc_btn.length; i++){
		let ttl = acc_btn[i];
		let content = ttl.nextElementSibling;
		ttl.addEventListener('click',()=>{
			ttl.classList.toggle('open');
			content.classList.toggle('open');
			if (content.style.height) {
				content.style.height = null;
			} else {
				content.style.height = content.scrollHeight + 'px';
			}
		});
	}
	
	// anchor link
	const anchorLinks = document.querySelectorAll('a[href^="#"]')
	const anchorLinksArr = Array.prototype.slice.call(anchorLinks);
	const header = document.querySelector('header');

	anchorLinksArr.forEach(link => {
		link.addEventListener('click', e => {
		  e.preventDefault();
		  const targetId = link.hash;
		  const targetElement = document.querySelector(targetId);
		  const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
		  const headerHeight = header.offsetHeight;
		  const totalScrollAmount = targetOffsetTop - headerHeight;
		  window.scrollTo({
			top: totalScrollAmount,
			behavior: "smooth"
		  });
		});
	});
});


document.addEventListener('DOMContentLoaded', function () {

	/* --------------- swiper --------------- */
	const productSlide01 = new Swiper('.swiper1', {
		speed:600,
		loop: true,
		lazyLoading: true,
		slidesPerView:1,
		spaceBetween:20,
		autoplay:{
			delay: 5000,
		},
		navigation:{
			nextEl:".swiper-button-next",
			prevEl:".swiper-button-prev",
		},
		pagination:{
			el:".swiper-pagination",
			type:"fraction",
			clickable: true,
		},
		breakpoints:{
			750: {
				centeredSlides: true,
			},
		},
	});
	const productSlide02 = new Swiper('.swiper2', {
		speed:600,
		loop: true,
		lazyLoading: true,
		slidesPerView:1,
		spaceBetween:20,
		autoplay:{
			delay: 5000,
		},
		navigation:{
			nextEl:".swiper-button-next",
			prevEl:".swiper-button-prev",
		},
		pagination:{
			el:".swiper-pagination",
			type:"fraction",
			clickable: true,
		},
		breakpoints:{
			750: {
				centeredSlides: true,
			},
		},
	});
	const productSlide03 = new Swiper('.swiper3', {
		speed:600,
		loop: true,
		lazyLoading: true,
		slidesPerView:1,
		spaceBetween:20,
		autoplay:{
			delay: 5000,
		},
		navigation:{
			nextEl:".swiper-button-next",
			prevEl:".swiper-button-prev",
		},
		pagination:{
			el:".swiper-pagination",
			type:"fraction",
		},
		breakpoints:{
			750: {
				centeredSlides: true,
			},
		},
	});
	const productSlide04 = new Swiper('.swiper4', {
		speed:600,
		loop: true,
		lazyLoading: true,
		slidesPerView:1,
		spaceBetween:20,
		autoplay:{
			delay: 5000,
		},
		navigation:{
			nextEl:".swiper-button-next",
			prevEl:".swiper-button-prev",
		},
		pagination:{
			el:".swiper-pagination",
			type:"fraction",
		},
		breakpoints:{
			750: {
				centeredSlides: true,
			},
		},
	});
	const productSlide05 = new Swiper('.swiper5', {
		speed:600,
		loop: true,
		lazyLoading: true,
		slidesPerView:1,
		spaceBetween:20,
		autoplay:{
			delay: 5000,
		},
		navigation:{
			nextEl:".swiper-button-next",
			prevEl:".swiper-button-prev",
		},
		pagination:{
			el:".swiper-pagination",
			type:"fraction",
		},
		breakpoints:{
			750: {
				centeredSlides: true,
			},
		},
	});
	const productSlide06 = new Swiper('.swiper6', {
		speed:600,
		loop: true,
		lazyLoading: true,
		slidesPerView:1,
		spaceBetween:20,
		autoplay:{
			delay: 5000,
		},
		navigation:{
			nextEl:".swiper-button-next",
			prevEl:".swiper-button-prev",
		},
		pagination:{
			el:".swiper-pagination",
			type:"fraction",
		},
		breakpoints:{
			750: {
				centeredSlides: true,
			},
		},
	});
	const productSlide07 = new Swiper('.swiper7', {
		speed:600,
		loop: true,
		lazyLoading: true,
		slidesPerView:1,
		spaceBetween:20,
		autoplay:{
			delay: 5000,
		},
		navigation:{
			nextEl:".swiper-button-next",
			prevEl:".swiper-button-prev",
		},
		pagination:{
			el:".swiper-pagination",
			type:"fraction",
		},
		breakpoints:{
			750: {
				centeredSlides: true,
			},
		},
	});
	
});
